import { render, staticRenderFns } from "./HeaderPersonal.vue?vue&type=template&id=e487eae8"
import script from "./HeaderPersonal.vue?vue&type=script&lang=js"
export * from "./HeaderPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports